<script>
import Layout from "../../layouts/auth";
import {
  // authMethods,
  // authFackMethods,
  authApiMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import { PostApiAction } from '../../../helpers/apiActions';

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      rememberMe: "checked",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      startSubmitLogging: false,
      secretKey: ''
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    // ...authMethods,
    // ...authFackMethods,
    ...notificationMethods,
    ...authApiMethods,
    // Try to log the user in with the username
    // and password they provided.
    processLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { email, password } = this;
        this.startSubmitLogging = true
        this.apiLogin({
          email,
          password
        }).finally(() => {
          this.startSubmitLogging = false
        });
      }
    },
  },
  mounted() {
    const secret = this.$route.query.secret;
    let _vm = this
    if (secret) {
      _vm.secretKey = secret;
      PostApiAction("admin/auth/ip-whitelist", { secret }).then((res) => {
        if (res.status != 'success') {
          _vm.$toast.error(res.message, {
            position: "top-right",
            timeout: 1000,
            closeOnClick: true
          });
        }
      }).finally(() => {
        _vm.secretKey = '';
        _vm.$router.push('/login');
      });
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center" v-if="secretKey.length === 0">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden mb-2">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome Back !</h5>
                  <p>Sign in to Cybershop.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert>
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="pb-0" @submit.prevent="processLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Enter email"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Enter password"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <b-form-checkbox
                  v-model="rememberMe"
                  switch
                  size="sm"
                  value="checked"
                  unchecked-value="not_checked"
                >
                  &nbsp;Remember me
                </b-form-checkbox>
              <div class="mt-1 d-grid">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  :disabled="startSubmitLogging">
                  <span v-if="!startSubmitLogging">Log In</span>
                  <span v-else><i class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i></span>
                </b-button>
              </div>
              <!--div class="mt-2 text-center">
                <router-link to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> Forgot your password?
                </router-link>
              </div-->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="text-center mt-2">
          © {{ new Date().getFullYear() }} Team Cybershop <i class="mdi mdi-heart text-danger"></i>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <div style="margin: auto" v-else>
      <div
        class="loading-item-specific text-center"
        style="font-size: 32px">
        <i class="el-icon-loading"></i> Auto-Whitelisting Device IP Address
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
body {
  background: #eee
}
</style>
